import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Snackbar from 'components/molecules/alerts/Snackbar';
import { whitePages } from 'constants/components/rules';
import PropTypes from 'prop-types';

import LoadingComponent from '../../../LoadingComponent';
import { Container, Content } from './styles';

const BlankLayout = ({ noPadding }) => {
    const location = useLocation();
    const whitePage = whitePages.includes(location.pathname);

    return (
        <Container whitePage={whitePage}>
            <Snackbar />

            <Content noPadding={noPadding}>
                <React.Suspense fallback={<LoadingComponent />}>
                    <Outlet />
                </React.Suspense>
            </Content>
        </Container>
    );
};

BlankLayout.propTypes = {
    noPadding: PropTypes.bool
};

export default BlankLayout;
